import { Component, Input } from '@angular/core';

@Component({
	standalone: false,
	selector: 'qe-plus-icon',
	templateUrl: './plus-icon.component.html',
})
export class PlusIconComponent {
	@Input() public readonly variableName?: string = 'brandPrimary';

	constructor() {}
}
